import { render, staticRenderFns } from "./SysConfig.vue?vue&type=template&id=37a02fef"
import script from "./SysConfig.vue?vue&type=script&lang=js"
export * from "./SysConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports